import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

/** Interface for object which can store both:
 * An ActivatedRouteSnapshot, which is useful for determining whether or not you should attach a route (see this.shouldAttach)
 * A DetachedRouteHandle, which is offered up by this.retrieve, in the case that you do want to attach the stored route
 */
interface RouteStorageObject {
    snapshot: ActivatedRouteSnapshot;
    handle: DetachedRouteHandle;
}

export class CustomRouteReuseStrategy implements RouteReuseStrategy {

    /**
     * Object which will store RouteStorageObjects indexed by keys
     * The keys are a path (as in route.routeConfig.path)
     */
    storedRoutes: { [key: string]: RouteStorageObject } = {};

    /**
     * Decides if the route should be stored
     * @param route This is the current route before the user navigates away.
     * @returns boolean indicating if the route should be stored
     */
    shouldDetach(): boolean {
        return false;
    }

    /**
     * Constructs object of type `RouteStorageObject` to store, and then stores it for later attachment
     * @param route This is stored for later comparison to requested routes
     * @param handle Later to be retrieved by `this.retrieve`
     */
    store(): void {
        return;
    }

    /**
     * Determines whether or not there is a stored route that should be rendered in place of requested route
     * @param route The route the user requested
     * @returns boolean indicating whether or not to render the stored route
     */
    shouldAttach(): boolean {
        return false;
    }

    /**
     * Finds the locally stored instance of the requested route, if it exists, and returns it
     * @param route New route the user has requested
     * @returns DetachedRouteHandle object which can be used to render the component
     */
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        // return null if the path does not have a routerConfig OR if there is no stored route for that routerConfig
        if (!route.routeConfig || !this.storedRoutes[route.routeConfig.path]) return null;

        /** returns handle when the route.routeConfig.path is already stored */
        return this.storedRoutes[route.routeConfig.path].handle;
    }

    /**
     * Determines whether or not the current route should be reused
     * @param future The route the user is going to, as triggered by the router
     * @param curr The route the user is currently on
     * @returns boolean indicating whether or not the current route should be reused
     */
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (future.routeConfig?.path === 'account/:customerAxCode/draftorder/:id' && (curr.routeConfig?.path === 'account/:customerAxCode/draftorder' || curr.routeConfig?.path === 'account/:customerAxCode/draftorder/:id')) {
            return true;
        }
        return future.routeConfig === curr.routeConfig;
    }
}
